module.exports = __webpack_public_path__ + "static/media/preloader.7bf3d290.gif";